import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/logo.svg';
import usePackPermissions from '../../hooks/usePackPermissions';

const PACK_DARK_COLORS = {
  Start:   'bg-[#19C37D]/20 text-[#19C37D] border-[#19C37D]/25',
  Pro:     'bg-blue-500/20 text-blue-300 border-blue-400/30',
  ProPlus: 'bg-purple-500/20 text-purple-300 border-purple-400/30',
};

const HomeIcon     = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>;
const DashIcon     = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>;
const CarIcon      = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.3 1L3 12v4c0 .6.4 1 1 1h1m2.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-9.5 0h8" /></svg>;
const ClientsIcon  = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>;
const CalIcon      = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>;
const DocIcon      = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>;
const InvoiceIcon  = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" /></svg>;
const CautionIcon  = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>;
const ShieldIcon   = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>;
const OilIcon      = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" /></svg>;
const CheckIcon    = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" /></svg>;
const GearIcon     = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>;
const BuildingIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>;
const CreditCardIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h.01M11 15h2M5 5h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z" /></svg>;
const UsersIcon    = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>;
const ShieldAdminIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>;

const NavItem = ({ to, label, icon, end, onClose }) => (
  <NavLink
    to={to}
    end={end}
    onClick={onClose}
    className={({ isActive }) =>
      'group flex items-center gap-3 px-3 py-2.5 rounded-xl mb-0.5 text-sm font-medium transition-all duration-150 ' +
      (isActive
        ? 'bg-[#19C37D]/15 text-[#19C37D] font-semibold'
        : 'text-white/60 hover:bg-white/[0.07] hover:text-white')
    }
  >
    <span className="flex-shrink-0 transition-transform duration-150 group-hover:scale-110">{icon}</span>
    <span className="truncate">{label}</span>
  </NavLink>
);

const AdminNavItem = ({ to, label, icon, onClose }) => (
  <NavLink
    to={to}
    onClick={onClose}
    className={({ isActive }) =>
      'group flex items-center gap-3 px-3 py-2.5 rounded-xl mb-0.5 text-sm font-medium transition-all duration-150 ' +
      (isActive
        ? 'bg-purple-400/20 text-purple-300 font-semibold'
        : 'text-white/50 hover:bg-white/[0.07] hover:text-white')
    }
  >
    <span className="flex-shrink-0 transition-transform duration-150 group-hover:scale-110">{icon}</span>
    <span className="truncate">{label}</span>
  </NavLink>
);

const SectionLabel = ({ children, admin = false }) => (
  <p className={`text-[10px] font-bold uppercase tracking-widest px-3 mb-1.5 ${admin ? 'text-purple-400/60' : 'text-white/35'}`}>
    {children}
  </p>
);

const Sidebar = ({ onClose }) => {
  const user = useSelector(s => s.auth.user);
  const isSuperAdmin = user?.role === 'SuperAdmin';
  const { t } = useTranslation();
  const { canAccess, pack, packLabel } = usePackPermissions();

  const showDashboard   = canAccess('dashboard');
  const showMaintenance = canAccess('maintenance');

  const packColors = PACK_DARK_COLORS[pack] || 'bg-white/10 text-white/70 border-white/20';

  return (
    <aside className="bg-[#0F2E25] w-60 min-h-screen flex flex-col flex-shrink-0 h-full overflow-y-auto">

      {/* Logo */}
      <div className="px-5 py-4 flex items-center gap-3 border-b border-white/10 sticky top-0 bg-[#0F2E25] z-10 flex-shrink-0">
        <img src={logo} alt="Logo" className="h-8 w-8 object-contain" />
        <span className="font-bold text-white text-base tracking-tight">Kreylik</span>
        {onClose && (
          <button
            onClick={onClose}
            className="ml-auto p-1.5 rounded-lg text-white/40 hover:bg-white/10 hover:text-white md:hidden transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>

      {/* Pack badge — clients uniquement */}
      {user?.role === 'Client' && pack && (
        <div className="px-4 pt-3 pb-0">
          <span className={`inline-block px-2.5 py-0.5 text-xs font-bold rounded-lg border ${packColors}`}>
            {packLabel}
          </span>
        </div>
      )}

      {/* Navigation */}
      <nav className="p-3 flex-1 space-y-4 mt-1">

        {user?.role === 'Client' && (
          <>
            <div>
              <SectionLabel>{t('nav.fleet')}</SectionLabel>
              {showDashboard && (
                <NavItem to="/" label={t('nav.dashboard')} icon={<DashIcon />} end onClose={onClose} />
              )}
              <NavItem to="/vehicles"     label={t('nav.vehicles')}     icon={<CarIcon />}     onClose={onClose} />
              <NavItem to="/clients"      label={t('nav.clients')}      icon={<ClientsIcon />} onClose={onClose} />
              <NavItem to="/reservations" label={t('nav.reservations')} icon={<CalIcon />}     onClose={onClose} />
            </div>

            <div>
              <SectionLabel>{t('nav.finance')}</SectionLabel>
              <NavItem to="/contrats"    label={t('nav.contrats')}    icon={<DocIcon />}        onClose={onClose} />
              <NavItem to="/factures"    label={t('nav.factures')}    icon={<InvoiceIcon />}    onClose={onClose} />
              <NavItem to="/cautions"    label={t('nav.cautions')}    icon={<CautionIcon />}    onClose={onClose} />
              {canAccess('financement') && (
                <NavItem to="/financements" label={t('nav.financements')} icon={<CreditCardIcon />} onClose={onClose} />
              )}
            </div>

            {showMaintenance && (
              <div>
                <SectionLabel>{t('nav.maintenance')}</SectionLabel>
                <NavItem to="/assurances"         label={t('nav.assurances')}       icon={<ShieldIcon />} onClose={onClose} />
                <NavItem to="/vidanges"           label={t('nav.vidanges')}         icon={<OilIcon />}    onClose={onClose} />
                <NavItem to="/visites-techniques" label={t('nav.vistesTechniques')} icon={<CheckIcon />}  onClose={onClose} />
              </div>
            )}

            <div>
              <SectionLabel>{t('nav.administration')}</SectionLabel>
              <NavItem to="/settings" label={t('nav.settings')} icon={<GearIcon />} onClose={onClose} />
            </div>
          </>
        )}

        {isSuperAdmin && (
          <div>
            <SectionLabel admin>{t('nav.superAdmin')}</SectionLabel>
            <AdminNavItem to="/admin/superadmins" label="Super Admin"            icon={<ShieldAdminIcon />} onClose={onClose} />
            <AdminNavItem to="/admin/tenants"     label={t('nav.agencies')}      icon={<BuildingIcon />}    onClose={onClose} />
            <AdminNavItem to="/admin/users"       label={t('admin.users.title')} icon={<UsersIcon />}       onClose={onClose} />
            <AdminNavItem to="/admin/agents"      label={t('nav.agents')}        icon={<UsersIcon />}       onClose={onClose} />
          </div>
        )}

        {user?.role === 'Agent' && (
          <div>
            <SectionLabel admin>{t('nav.agentSpace')}</SectionLabel>
            <AdminNavItem to="/admin/tenants" label={t('nav.agentMenu.agencies')}      icon={<BuildingIcon />} onClose={onClose} />
            <AdminNavItem to="/admin/users"   label={t('nav.agentMenu.subscriptions')} icon={<CalIcon />}      onClose={onClose} />
          </div>
        )}
      </nav>

      {/* User card */}
      {user && (
        <div className="p-3 border-t border-white/10 flex-shrink-0">
          <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl bg-white/[0.07]">
            <div className="w-8 h-8 rounded-full bg-[#19C37D]/20 border border-[#19C37D]/30 flex items-center justify-center flex-shrink-0">
              <span className="text-sm font-bold text-[#19C37D]">
                {(user.username || '?').charAt(0).toUpperCase()}
              </span>
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-white truncate">{user.username}</p>
              <p className={`text-xs font-medium mt-0.5 ${isSuperAdmin ? 'text-purple-400' : 'text-[#19C37D]'}`}>
                {t(`roles.${user.role}`, { defaultValue: user.role })}
              </p>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;

